import { Component, OnInit } from '@angular/core';
import { Brand } from '../../../core/models/brand';
import { SpotLiftRecord } from '../../portal/reporting-dashboard/lift-by-spot-tile/lift-by-spot-tile.component';
import * as moment from 'moment-timezone';
import { Moment } from 'moment-timezone';
import { Subscription } from 'rxjs';
import { DashboardReportingQueryTypes, IReportDateRange, ReportDao } from '../../../core/services/dao/reportDao';
import { BrandDao } from '../../../core/services/dao/brandDao';
import { UserDao } from '../../../core/services/dao/userDao';
interface IReportDateRangeOption {
  label: string;
  value: IReportDateRange;
}

@Component({
  selector: 'app-demo-dashboard',
  templateUrl: './demo-dashboard.component.html',
  styleUrls: ['./demo-dashboard.component.scss']
})
export class DemoDashboardComponent implements OnInit {
  public dateRangeOptions: IReportDateRangeOption[] = [];
  public selectedDate: any;
  public brand: Brand;
  public showDashboard = true;
  public showFullLift = false;
  public spotLiftRecords: SpotLiftRecord[];
  public averageLift: number;
  public timezone = 'America/Chicago';

  public pickedStart;
  public pickedEnd;
  public creatives = [];

  public reportRangeStartFilter = (d: Date | null): boolean => {
    let start = moment.tz(d, this.timezone).startOf('day');
    return start.isSameOrBefore(moment.tz(this.timezone));
  };

  public reportRangeEndFilter = (d: Date | null): boolean => {
    let start = moment.tz(d, this.timezone).startOf('day').subtract(90, 'days');
    if (this.pickedStart && moment.tz(this.pickedStart, this.timezone).isBefore(start)) {
      return false;
    } else if (this.pickedStart) {
      return true;
    } else {
      return false;
    }
  };

  private lastUpdated: Date | Moment;
  private subs: Array<Subscription> = [];

  constructor(private reportDao: ReportDao) {
    this.creatives = ['GE31W2', 'GE31W1', 'GF31W1', 'GF35W1', 'GG35W1', 'GG35W6'];
  }

  ngOnInit() {
    this.initDateProps();
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  tzChange(tz) {
    this.timezone = tz;
  }

  startChange(evt) {
    this.pickedEnd = null;
  }

  showLiftFull(evt) {
    this.spotLiftRecords = evt.spots;
    this.averageLift = evt.averageLift;
    this.showDashboard = false;
    this.showFullLift = true;
  }

  _showDashboard() {
    this.showDashboard = true;
    this.showFullLift = false;
  }

  initDateProps(): void {
    let end = moment.tz(this.timezone).endOf('day').subtract(1, 'days').tz('UTC');
    let start = moment.tz(this.timezone).startOf('day').subtract(7, 'days').tz('UTC');
    this.dateRangeOptions.push(this.formatDateOption(start, end, 'Week'));
    this.selectedDate = this.dateRangeOptions[0].value;
    this.lastUpdated = moment.tz('UTC').subtract(1, 'day').startOf('day');
    this.reportDao.setReportDateRange(this.selectedDate);
    let twoWeeks = moment.tz(this.timezone).startOf('day').subtract(14, 'days').tz('UTC');
    this.dateRangeOptions.push(this.formatDateOption(twoWeeks, end, 'Two Weeks'));
    let month = moment.tz(this.timezone).startOf('day').subtract(30, 'days').tz('UTC');
    this.dateRangeOptions.push(this.formatDateOption(month, end, '30 Days'));
    let twoMonths = moment.tz(this.timezone).startOf('day').subtract(60, 'days').tz('UTC');
    this.dateRangeOptions.push(this.formatDateOption(twoMonths, end, '60 Days'));
    let threeMonths = moment.tz(this.timezone).startOf('day').subtract(90, 'days').tz('UTC');
    this.dateRangeOptions.push(this.formatDateOption(threeMonths, end, '90 Days'));
  }

  handleDateChange(evt) {
    if (!(evt.value === 'custom')) {
      this.lastUpdated = moment.tz('UTC').subtract(1, 'day').startOf('day');
      this.reportDao.setReportDateRange(evt.value);
    }
  }

  handleCustomSubmit(evt) {
    this.reportDao.setReportDateRange({
      start: moment.tz(this.pickedStart, this.timezone).startOf('day').tz('UTC'),
      end: moment.tz(this.pickedEnd, this.timezone).endOf('day').tz('UTC')
    });
  }

  private formatDateOption(start: Date | Moment, end: Date | Moment, labelDesc: string): IReportDateRangeOption {
    return {
      value: { start, end },
      label: `${labelDesc} (${moment.tz(start, this.timezone).format('M/DD')}-${moment
        .tz(end, this.timezone)
        .format('M/DD')})`
    };
  }

  checkCustomDateRange() {
    let isAfter = moment.tz(this.pickedStart, 'UTC').isSameOrBefore(moment.tz(this.pickedEnd, 'UTC'));
    let diff = Math.abs(
      moment
        .tz(this.pickedStart, this.timezone)
        .startOf('day')
        .tz('UTC')
        .diff(moment.tz(this.pickedEnd, this.timezone).endOf('day').tz('UTC'), 'days')
    );
    let valid = isAfter && diff <= 91 && this.pickedStart && this.pickedEnd;
    return !valid;
  }
}
